"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _ReactSVGIcon = _interopRequireDefault(require("@micado-digital/react-svg-icon/ReactSVGIcon"));

var _react2 = require("swiper/react");

require("swiper/css/effect-fade");

require("swiper/css");

var _Item = _interopRequireDefault(require("./Item"));

var _ReactGallery = _interopRequireDefault(require("./ReactGallery05.styles"));

var _swiper = require("swiper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ReactGallery05 = function ReactGallery05(_ref) {
  var absoluteMediaURLs = _ref.absoluteMediaURLs,
      elements = _ref.elements,
      mediaFormats = _ref.mediaFormats,
      navNext = _ref.navNext,
      navPrev = _ref.navPrev,
      resourceURL = _ref.resourceURL,
      showPagination = _ref.showPagination,
      showNavigation = _ref.showNavigation,
      SwiperProps = _ref.SwiperProps;
  var css = (0, _ReactGallery.default)();
  return /*#__PURE__*/_react.default.createElement(_Box.default, {
    className: (0, _clsx.default)("mco-gallery-05", css.root)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.swiperRoot, "mco-gallery-05__swiperRoot")
  }, /*#__PURE__*/_react.default.createElement(_react2.Swiper, _extends({
    className: (0, _clsx.default)(css.swiper, "mco-gallery-05-swiper", "swiper-container"),
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    watchOverflow: true,
    modules: [_swiper.EffectFade, _swiper.Pagination, _swiper.Navigation],
    navigation: showNavigation ? {
      prevEl: navPrev ? ".mco-gallery-05-swiper-nav__prev" : undefined,
      nextEl: navNext ? ".mco-gallery-05-swiper-nav__next" : undefined
    } : false,
    pagination: showPagination ? {
      el: ".swiper-pagination",
      type: "fraction"
    } : false,
    slidesPerView: 1,
    speed: 1000
  }, SwiperProps), elements.map(function (item) {
    var _item$media;

    return /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
      key: item.id
    }, /*#__PURE__*/_react.default.createElement(_Item.default, {
      absoluteMediaURLs: absoluteMediaURLs,
      link: item === null || item === void 0 ? void 0 : item.link,
      media: item === null || item === void 0 ? void 0 : (_item$media = item.media) === null || _item$media === void 0 ? void 0 : _item$media[0],
      mediaFormats: mediaFormats,
      resourceURL: resourceURL,
      text: item === null || item === void 0 ? void 0 : item.addition,
      title: item === null || item === void 0 ? void 0 : item.text
    }));
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-gallery-05__bottom-wrapper", css.bottomWrapper)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("swiper-pagination", css.swiperPagination)
  }), showNavigation && /*#__PURE__*/_react.default.createElement("div", {
    className: css.swiperNavigation
  }, navPrev && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-gallery-05-swiper-nav__prev", css.swiperNav, css.swiperNavPrev)
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: navPrev
  })), navNext && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)("mco-gallery-05-swiper-nav__next", css.swiperNav, css.swiperNavNext)
  }, /*#__PURE__*/_react.default.createElement(_ReactSVGIcon.default, {
    src: navNext
  })))))));
};

ReactGallery05.propTypes = {
  absoluteMediaURLs: _propTypes.default.bool,
  elements: _propTypes.default.array.isRequired,
  mediaFormats: _propTypes.default.object.isRequired,
  navNext: _propTypes.default.string,
  navPrev: _propTypes.default.string,
  resourceURL: _propTypes.default.string,
  showPagination: _propTypes.default.bool,
  showNavigation: _propTypes.default.bool,
  SwiperProps: _propTypes.default.object
};
var _default = ReactGallery05;
exports.default = _default;